import { useContext, useEffect, useState } from "react";
import {
  BellIcon,
  CalanderIcon,
  LocationIcon,
  TrophyIcon
} from "../../../../components/GlobalIcons";
import "./style.css";
import { formatDate, getTime } from "../../../../utils/func";
import Skeleton from "react-loading-skeleton";
import { HiBellAlert } from "react-icons/hi2";
import { ADD_WATCHLIST_API } from "../../../../APIs";
import { filterDataContext } from "../../../../App";
import { toast } from "react-toastify";

const EventDetailHeader = ({ eventData, handlerSetWhislist, eventLoader, checkForWishListStatus }) => {
  let First_team = "";
  let Second_team = "";
  const [watchListStatus, setWatchListStatus] = useState(false)

  useEffect(() => {
    setWatchListStatus(checkForWishListStatus)
  }, [checkForWishListStatus])


  if (eventData?.event_name) {
    const splitted_Name = eventData?.event_name.split("vs");
    First_team = splitted_Name[0];
    Second_team = splitted_Name[1];
  }

  const handleAddToWatchList = async () => {
    if (watchListStatus) {
      return
    }
    try {
      const payload = {
        event_id: eventData?.event_id
      }
      const response = await ADD_WATCHLIST_API(payload)
      if (response && response?.status) {
        setWatchListStatus(true)
        toast.success(response?.message)
      } else {
        toast.error(response?.message)
      }
    } catch (error) {
      console.log(error, "ADD_WATCHLIST_API")
    }
  }

  return (
    <div className="teams_Vs">
      <div className="teams_name_vs">
        {eventLoader ? (
          <Skeleton
            width={250}
            height={40}
            count={1}
            style={{ "--base-color": "#ccc", "--highlight-color": "#f5f5f5" }}
            inline
          />
        ) : (
          <>
            {First_team && <h3>{First_team}</h3>}
            {Second_team && (
              <>
                <p>Vs</p>
                <h3>{Second_team}</h3>
              </>
            )}
            <span
              className="bell_vs_team"
              onClick={() => { handleAddToWatchList() }}
              title={watchListStatus ? "Remove from watchlist" : "Add to watchlist"}
            >
              {
                watchListStatus ? <HiBellAlert className="wishlistIcon" />
                  :
                  <BellIcon />
              }
            </span>
          </>
        )}
      </div>
      <div className="team_Vs_details">
        <p>
          <span>
            <LocationIcon />
          </span>
          {eventLoader ? (
            <Skeleton
              width={150}
              height={10}
              count={1}
              style={{ "--base-color": "#ccc", "--highlight-color": "#f5f5f5" }}
              inline
            />
          ) : (
            eventData?.venue_name
          )}
        </p>
        <p>
          <span>
            <TrophyIcon />
          </span>{" "}
          {eventLoader ? (
            <Skeleton
              width={100}
              height={10}
              count={1}
              style={{ "--base-color": "#ccc", "--highlight-color": "#f5f5f5" }}
              inline
            />
          ) : (
            `${eventData.tournament_name} (${eventData.season})`
          )}
        </p>
        <p>
          <span>
            <CalanderIcon />
          </span>{" "}
          {eventLoader ? (
            <Skeleton
              width={120}
              height={10}
              count={1}
              style={{ "--base-color": "#ccc", "--highlight-color": "#f5f5f5" }}
              inlinea
            />
          ) : (
            `${formatDate(eventData.date_start)} ${getTime(
              eventData.date_start
            )}`
          )}
        </p>
      </div>
    </div>
  );
};

export default EventDetailHeader;
